module.exports = __webpack_public_path__ + "static/sohamheadshot-081ea9631cbdd5b6e6a7408304166241.jpg";